import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Clients from "@/components/Clients";
import Services from "@/components/Services";
import SupplementalServices from "@/components/SupplementalServices";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Landing = () => (
  <div data-testid="landing-page">
    <Navigation />
    <main>
      <Hero />
      <Clients />
      <Services />
      <SupplementalServices />
      <About />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            border: "1px solid rgba(245,239,224,0.18)",
            borderRadius: 10,
            background: "#1D1915",
            color: "#F5EFE0",
            fontFamily: "Atkinson Hyperlegible, sans-serif",
            fontSize: 14,
            padding: "14px 16px",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
